import { SellerCenterSellerApiClient } from '@/apis';

export default {
  getCategories () {
    return SellerCenterSellerApiClient.get('/seller/preferences', {
      params: {
        platform: 'WEB',
      },
    });
  },

  updateCategory (body) {
    return SellerCenterSellerApiClient.put('/seller/preferences/update-by-seller-id', body);
  },
};
